export default __webpack_public_path__ + "static/media/IELTS.e40c8bbe.png";